import React from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import 'normalize.css';


export default function Home(){
    return(
      <main id="content" className="content">

      <section className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-150" style={{backgroundImage: "url(assets/demo/bg/bg-14.jpg)"}} data-parallax="true" data-parallax-options={{ "parallaxBG": true }}>

      <div className="container">
        <div className="row">
      
          <div className="lqd-column col-md-6" >

            <h1 className="text-white pr-md-5 mt-0 mb-40" data-split-text="true" data-split-options={{ "type":"lines" }}>Effortless Efficiency. Nationwide Trust.</h1>
            <p className="text-white font-size-16 lh-185 pr-md-7 mb-60" data-split-text="true" data-split-options={{ "type":"lines" }}>Welcome to DocBoyz, where innovation meets reliability in transforming financial operations. As a trusted partner for banks, NBFCs, and financial institutions, we specialize in simplifying complex processes like document collection, verification, and agri-risk mitigation.</p>

            <a className="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient px-2">
              <span>
                <span className="btn-gradient-bg"></span>
                <span className="btn-txt"><Link to="/CollectKart" >Explore our Services</Link></span>
                <span className="btn-gradient-bg btn-gradient-bg-hover"></span>
                <svg className="btn-gradient-border" width="100%" height="100%">
                  <defs>
                    <linearGradient id="svg-border-1" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%"></stop>
                      <stop offset="100%"></stop>
                    </linearGradient>
                  </defs>
                  <rect x="0.5" y="0.5" rx="29.5" ry="29.5" width="100%" height="100%" stroke="url(#svg-border-1)"></rect>
                </svg>
              </span>
            </a>

            <a className="btn btn-naked text-uppercase fresco">
              <span>
                {/* <span className="btn-txt" style={{ color: "#ffffff" }}>Watch our video</span> */}
                {/* <span className="btn-icon font-size-30 text-primary"><i className="icon-music_play_button"></i></span> */}
              </span>
            </a>
            <br/><br/><br/><br/>

          </div>

          <div className="lqd-column col-md-6 hidden-xs hidden-sm">

            <div className="lqd-parallax-images-2" >

              <div className="liquid-img-group-container">
                <div className="liquid-img-group-inner">
                  <div className="liquid-img-group-single" data-shadow-style="3" data-roundness="8">
                    <div className="liquid-img-group-img-container">
                      <div className="liquid-img-container-inner" data-parallax="true" data-parallax-from={{ "translateX":-40,"translateY":1 }} data-parallax-to={{ "translateX":-17,"translateY":-27 }} data-parallax-options={{ "overflowHidden":false,"easing":"linear" }}>
                        <figure>
                          <img alt="Manage" src="assets/img/banners/slide-1.png" />
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="liquid-img-group-container w-30">
                <div className="liquid-img-group-inner">
                  <div className="liquid-img-group-single" data-shadow-style="3" data-roundness="8">
                    <div className="liquid-img-group-img-container">
                      <div className="liquid-img-container-inner" data-parallax="true" data-parallax-from={{ "translateX":1,"translateY":1 }} data-parallax-to={{ "translateX":-45,"translateY":-69 }} data-parallax-options={{ "overflowHidden":false,"easing":"linear" }}>
                        <figure>
                          {/* <img alt="Manage" src="assets/img/banners/slide-3.png" /> */}
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="liquid-img-group-container w-55">
                <div className="liquid-img-group-inner">
                  <div className="liquid-img-group-single" data-shadow-style="3" data-roundness="8">
                    <div className="liquid-img-group-img-container">
                      <div className="liquid-img-container-inner" data-parallax="true" data-parallax-from={{ "translateX":-90,"translateY":50 }} data-parallax-to={{ "translateX":-56,"translateY":-181 }} data-parallax-options={{ "overflowHidden":false,"easing":"linear" }}>
                        {/* <figure><img alt="Manage" src="assets/img/logo/slide-2.png" /></figure> */}
                      </div>
                   </div>   {/*   D:\Docboyz_Oct_pro\my-app\my-app\public\assets\img\logo\New.png */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="one-row_bottom_divider" style={{ height: "180px" }}>
          <svg fill="#ffffff" xmlns="https://www.w3.org/2000/svg" width="100%" height="182" viewbox="0 0 1920 182" preserveaspectratio="none">
            <path d="M1921.91,916.348c0.33,39.216-.34,79.431,0,118.642Q957.95,1035.5-6,1035V853c40.431,10.8,81,19.794,122.5,27.149,62.957,11.157,117.371,15.375,180.742,21.116,79.864,7.236,165.843,26.989,255.045,42.232,109.142,18.65,243.949,40.091,308.265,44.243,137.637,8.886,313.056-2.783,504.066-36.2,127.4-22.286,223.4-43.261,354.45-45.248A1569.414,1569.414,0,0,1,1921.91,916.348Z" transform="translate(0 -853)"></path>
          </svg>
        </div>
      </section>
      <section class="vc_row">
      <div class="container">
      <div class="row">

        <div class="lqd-column col-md-12">

          <div class="carousel-container carousel-nav-left carousel-nav-md carousel-dots-style1">

            <div  data-lqd-flickity='{"cellAlign":"left","prevNextButtons":false,"buttonsAppendTo":"self","pageDots":false,"groupCells":false,"wrapAround":true,"autoPlay":3000,"pauseAutoPlayOnHover":false}'>

              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/client-0.png" class="mt-10 w-200" alt="Client"/>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/DcbBank1.png" class="mt-10 w-200" alt="Client"/>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/client-1.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/client-6.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/Fibe.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/muthoot.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/Suryoday.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
             <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/logo.svg" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              {/*  <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/client-6.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/client-7.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/client-8.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/client-9.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div> */}

            </div>

          </div>

        </div>

      </div>
    </div>
    
  </section>
    <section id="about" class="vc_row bg-no-repeat pt-100 pb-100" style={{backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%"}}>
    <div class="container">
      <div class="row" >
        <div class="lqd-column col-md-12 mb-60">
          <header class="fancy-title">
            <h6 class="text-uppercase">Our Key Services</h6>
            {/* Streamlining Document Collection for a Seamless Future */}
            <h1>Streamlining <strong>Document Collection </strong>for a Seamless Future</h1>
          </header>
        </div>
        <div class="row">
          <div class="lqd-column col-md-4">
            <div class="iconbox iconbox-side iconbox-round iconbox-shadow iconbox-heading-sm iconbox-filled iconbox-filled iconbox-filled-hover iconbox-has-fill-element" id="iconbox-filled-2" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"#830bb0:#ba00ff","hoverColor":"#fff"}'>
              <span class="iconbox-fill-el iconbox-fill-el-hover bg-gradient-primary-tl"></span>
              <div class="iconbox-icon-wrap">
                <span class="iconbox-icon-container">
                <svg width="64px" height="64px" viewBox="0 0 64 64" enableBackground="new 0 0 64 64" xmlSpace="preserve">
                  <path strokeWidth="2" strokeMiterlimit="10" d="M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838 c-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M9.001000000000001,32A22.999,22.999 0,1,1 54.998999999999995,32A22.999,22.999 0,1,1 9.001000000000001,32"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M17,32A15,15 0,1,1 47,32A15,15 0,1,1 17,32"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M25.001,32A6.999,6.999 0,1,1 38.999,32A6.999,6.999 0,1,1 25.001,32"></path>
                </svg>
                </span>
              </div>
              <div class="contents">
                <h3>Docboyz- Document Collection</h3>
                <p>A platform that combines physical and digital solutions for collecting documents. Our system is built to grow with ease, allowing banks and financial companies to expand their operations across India...</p>
                {/* <a  class="see-more">See More</a> */}
                <a  class="btn btn-underlined text-uppercase btn-bordered border-thin btn-bordered-gradient btn-bordered-gradient-primary font-size-12 lh-15 font-weight-medium ltr-sp-2 text-dark">
                  <span>
                     <Link to="/CollectKart" >
                     <span class="btn-txt">Explore Now</span> 
                     </Link>
                     {/* li><Link to="/CollectKart">DB Document Collection</Link></li>
                                                                        <li><Link to="/DebtRecovery">DB Debt Recovery</Link></li> */}
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div class="lqd-column col-md-4">
          <div class="iconbox iconbox-side iconbox-round iconbox-shadow iconbox-heading-sm iconbox-filled iconbox-filled iconbox-filled-hover iconbox-has-fill-element" id="iconbox-filled-2" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"#830bb0:#ba00ff","hoverColor":"#fff"}'>
            <span class="iconbox-fill-el iconbox-fill-el-hover bg-gradient-primary-tl"></span>
            <div class="iconbox-icon-wrap">
              <span class="iconbox-icon-container">
                <svg version="1.1" xmlns="https://www.w3.org/2000/svg" xmlnsXlink="https://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" enableBackground="new 0 0 64 64" xmlSpace="preserve">
                  <path strokeWidth="2" strokeMiterlimit="10" d="M1,63L1,2L62,63Z"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M14,54L14,30L38,54Z"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M8,22L2,22"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M6,30L2,30"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M8,38L2,38"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M6,46L2,46"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M8,54L2,54"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M25,1L19,7L55,43L63,45L61,37Z"></path>
                  <path strokeWidth="2" strokeMiterlimit="10" d="M25,13L31,7"></path>
                </svg>
              </span>
            </div>
            <div class="contents">
    <h3>Docboyz - Collect Kart</h3>
    <p>
        Collect Kart is a debt collection software that streamlines the loan recovery process for Banks and NBFCs, using advanced technology and a human network for smoother, advisory debt collection... 
        <a  class="see-more">See More</a>
    </p>

    <a  class="btn btn-underlined text-uppercase btn-bordered border-thin btn-bordered-gradient btn-bordered-gradient-primary font-size-12 lh-15 font-weight-medium ltr-sp-2 text-dark">
        <span>
        <Link to="/DebtRecovery" >
            <span class="btn-txt">Explore Now</span>
            </Link>
        </span>
       
    </a>
</div>

            {/* <div class="contents">
              <h3>Docboyz - Collect Kart</h3>
              <p>Collect Kart is a debt collection software that streamlines the entire loan recovery process using our API. Built for Banks and NBFCs, it helps recover overdue payments with ease. By combining advanced technology with a strong human network, our platform supports a more advisory approach to debt collection, making the process smoother and less confrontational.</p>

              
              <a  class="btn btn-underlined text-uppercase btn-bordered border-thin btn-bordered-gradient btn-bordered-gradient-primary font-size-12 lh-15 font-weight-medium ltr-sp-2 text-dark">
                <span>
                  <span class="btn-txt">Explore Now</span>
                </span>
              </a>
            </div> */}
          </div>
          </div>
          <div class="lqd-column col-md-4">
            <div class="iconbox iconbox-side iconbox-round iconbox-shadow iconbox-heading-sm iconbox-filled iconbox-filled iconbox-filled-hover iconbox-has-fill-element" id="iconbox-filled-2" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"#830bb0:#ba00ff","hoverColor":"#fff"}'>
              <span class="iconbox-fill-el iconbox-fill-el-hover bg-gradient-primary-tl"></span>
              <div class="iconbox-icon-wrap">
                <span class="iconbox-icon-container mb-2">
                  <svg version="1.1" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xmlSpace="preserve"> <path stroke-width="2" stroke-miterlimit="10" d="M1 7 L63 7 L63 57 L1 57 Z"></path> <path stroke-width="2" stroke-miterlimit="10" d="M1,15L63,15"></path> <path stroke-width="2" stroke-miterlimit="10" d="M10,11L6,11"></path> <path stroke-width="2" stroke-miterlimit="10" d="M18,11L14,11"></path> <path stroke-width="2" stroke-miterlimit="10" d="M26,11L22,11"></path> <path stroke-width="2" stroke-miterlimit="10" d="M6,25L33,25"></path> <path stroke-width="2" stroke-miterlimit="10" d="M6,33L33,33"></path> <path stroke-width="2" stroke-miterlimit="10" d="M6,41L33,41"></path> <path stroke-width="2" stroke-miterlimit="10" d="M38 25 L57 25 L57 41 L38 41 Z"></path> </svg>
                </span>
              </div>
              <div class="contents">
                <h3>Regtech Api</h3>
                <p>
                Financial services are always at highest to risk of fraud. RegTech reliable and digitally evolved customer verification services are best tool to prevent fraud. Our Fintech Correspond...           
        <a  class="see-more">See More</a>
    </p>
                <a  class="btn btn-underlined text-uppercase btn-bordered border-thin btn-bordered-gradient btn-bordered-gradient-primary font-size-12 lh-15 font-weight-medium ltr-sp-2 text-dark">
                  <span>
                  <Link to="https://regtechapi.in/">
                    <span class="btn-txt">Explore Now</span>
                  </Link>
                  </span>
                </a>
              </div>
            </div>
          </div>


          {/* Other columns */}
        </div>
      </div>
    </div>
    <div class="lqd-space visible-lg visible-md" style={{ height: '100px' }}></div>

      <div class="row d-flex flex-wrap align-items-center">

        <div class="lqd-column col-md-6">

          <div class="liquid-img-group-container lqd-parallax-images-8"  data-ca-options='{"triggerHandler":"inview", "animationTarget":".liquid-img-group-single", "duration":"1600", "delay":"160", "easing":"easeOutQuint", "direction":"backward", "initValues":{"translateX":-85, "opacity":0}, "animations":{"translateX":0, "opacity":1}}'>
            <div class="liquid-img-group-inner">

              <div class="liquid-img-group-single" data-shadow-style="4" data-roundness="8" data-inview="true" data-animate-shadow="true">
                <div class="liquid-img-group-img-container">
                  <div class="liquid-img-container-inner" data-parallax="true" data-parallax-from='{"translateY":78}' data-parallax-to='{"translateY":-78}' data-parallax-options='{"overflowHidden":false, "easing":"linear"}'>
                    <figure class="w-90">
                      <img src="assets/img/banners/about-creintech-1.png" alt="Working with Ave"></img>
                    </figure>
                  </div>
                </div>
              </div>
              <div class="liquid-img-group-single" data-shadow-style="4" data-roundness="8" data-inview="true" >
                <div class="liquid-img-group-img-container">
                  <div class="liquid-img-group-content content-floated-mid">
                    <a  class="btn btn-naked fresco btn-icon-block btn-icon-top btn-icon-xlg btn-icon-circle btn-icon-solid" href="https://www.youtube.com/watch?v=AboF6nNJ8U0"
                      target="_blank"
                      rel="noopener noreferrer">
                      <span>
                        <span class="btn-icon"><i class="fa fa-play"></i></span>
                      </span>
                    </a>
                  </div>
                  <div class="liquid-img-container-inner" data-parallax="true" data-parallax-from='{"translateY":107}' data-parallax-to='{"translateY":-134}' data-parallax-options='{"overflowHidden":false,"easing":"linear"}'>
                    <figure>
                      <img src="assets/img/banners/about-creintech-2.png" alt="Working with Ave"></img>
                    </figure>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

        <div  data-ca-options='{"triggerHandler":"inview", "animationTarget":"all-childs", "duration":"1600", "delay":"160", "easing":"easeOutQuint", "direction":"forward", "initValues":{"translateY":30, "opacity":0}, "animations":{"translateY":0, "opacity":1}}' class="lqd-column col-md-5 col-md-offset-1">

          <header class="fancy-title">
            <h2 class="text-uppercase">About Us</h2>
            {/* <h1>Building Bigger Ideas <strong>Together </strong></h1> */}
          </header>

          <p class="font-size-18 lh-15 mb-55">At DocBoyz, we believe that behind every financial transaction lies a story—a dream of owning a home, a farmer’s hope for a bountiful harvest, or an entrepreneur’s vision to create something extraordinary. But too often, these dreams are hindered by inefficiencies, fraud, and outdated processes. That’s where we step in—not just as a service provider, but as the unsung heroes of the financial world.</p>

          <a  className="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient font-weight-bold px-2">
            <span>
              <span className="btn-gradient-bg"></span>
              <Link to="/CompanyPage" >
              <span className="btn-txt">More about us</span>
              </Link>
              <span className="btn-gradient-bg btn-gradient-bg-hover"></span>
              <svg xmlns="https://www.w3.org/2000/svg" xmlnsXlink="https://www.w3.org/1999/xlink" xmlSpace="preserve" className="btn-gradient-border" width="100%" height="100%">
                <defs>
                  <linearGradient id="svg-border-2" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%"></stop>
                    <stop offset="100%"></stop>
                  </linearGradient>
                </defs>
                <rect x="0.5" y="0.5" rx="29.5" ry="29.5" width="100%" height="100%" stroke="url(#svg-border-2)"></rect>
              </svg>
            </span>
          </a>

        </div>

      </div>
  </section>
  {/* <section id="services" class="vc_row pt-90 pb-50 bg-no-repeat" style={{backgroundImage: "url(assets/demo/bg/bg-77.svg)", backgroundPosition: "500% 0%"}}>
    <div class="container">

    <div class="row d-flex flex-wrap align-items-center">

<div class="lqd-column col-md-5 mb-30"  data-ca-options='{"triggerHandler":"inview", "animationTarget":"all-childs", "duration":"1600", "delay":"160", "easing":"easeOutQuint", "direction":"forward", "initValues":{"translateY":30, "opacity":0}, "animations":{"translateY":0, "opacity":1}}'>

  <header class="fancy-title pr-md-4">
    <h6 class="text-uppercase">Services</h6>
    <h2><strong>Our Core Services</strong></h2>
   
  </header>

  <p class="font-size-18 lh-15 mb-55">We provide a full range of website and mobile app development, Design services, AR-VR and other IT services and solutions globally. We readily adapt to your needs and offer solutions that deliver flexibility, high-quality results, that fit in your budget. We are your Technology Partner for Software Innovation and Market-leading Solutions.</p>

<a href="services.html" class="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient font-weight-bold px-2">
    <span>
      <span class="btn-gradient-bg"></span>
      <span class="btn-txt">See all services</span>
      <span class="btn-gradient-bg btn-gradient-bg-hover"></span>
      <svg className="btn-gradient-border" width="100%" height="100%"  style={{ filter: "url(#filter-seo-icon-4)" }}>
        <defs>
          <linearGradient id="svg-border-3" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"></stop>
            <stop offset="100%"></stop>
          </linearGradient>
        </defs>
        <rect x="0.5" y="0.5" rx="29.5" ry="29.5" width="100%" height="100%" stroke="url(#svg-border-3)"></rect>
      </svg>
    </span>
  </a>

</div>

<div class="lqd-column col-md-3 col-md-offset-1">

  <div class="lqd-column-inner" data-parallax="true" data-parallax-from='{"translateY":-30}' data-parallax-to='{"translateY":120}' data-parallax-options='{"duration":"2000", "easing":"linear", "reverse":true, "triggerHook":"onEnter", "overflowHidden": false}'>

    <div class="iconbox text-left iconbox-round iconbox-lg iconbox-filled iconbox-filled iconbox-filled-hover iconbox-icon-image iconbox-shadow pt-50 pb-40">
      <div class="iconbox-icon-wrap">
        <span class="iconbox-icon-container mb-35">
          <svg width="42.375" height="45.188" viewBox="0 0 42.375 45.188"  style={{ filter: "url(#filter-seo-icon-4)" }}>
          <defs>
            <filter id="filter-seo-icon-4" x="0.813" y="0" width="42.375" height="45.188" filterUnits="userSpaceOnUse">
              <feImage preserveAspectRatio="none" x="0.8125" y="0" width="42.375" height="45.188" result="image" xlinkHref="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDIuMzc1IiBoZWlnaHQ9IjQ1LjE4OCIgdmlld0JveD0iMCAwIDQyLjM3NSA0NS4xODgiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB5MT0iMjIuNTk0IiB4Mj0iNDIuMzc1IiB5Mj0iMjIuNTk0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZlNTA2YyIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmYzZhMmEiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjQyLjM3NSIgaGVpZ2h0PSI0NS4xODgiLz4KPC9zdmc+Cg=="></feImage>
              <feComposite result="composite" operator="in" in2="SourceGraphic"></feComposite>
              <feBlend result="blend" in2="SourceGraphic"></feBlend>
            </filter>
          </defs>
          <path filter="url(#filter-seo-icon-4)" d="M26.313,28.406l-8.531-5.719L9.25,28.406V0H26.313V28.406h0Zm-14.25-5.25,5.719-3.937L23.5,23.156V2.813H12.063V23.156h0ZM43.188,2.813H29.031V5.625H40.375v36.75H3.625V5.625H6.438V2.813H0.813V45.188H43.188V2.813h0Z" transform="translate(-0.813)"></path>
        </svg>
        </span>
      </div>
      <div class="contents">
        <h3>Web Development</h3>
        <p class="font-size-16 lh-165">Our web development services will help you to grow your business.</p>
      </div>
    </div>

    <div class="iconbox text-left iconbox-round iconbox-lg iconbox-filled iconbox-filled iconbox-filled-hover iconbox-icon-image iconbox-shadow pt-50 pb-40">
      <div class="iconbox-icon-wrap">
        <span class="iconbox-icon-container mb-35">
        <svg width="48" height="42.375" viewBox="0 0 48 42.375" style={{ filter: "url(#filter-seo-icon-6)" }}>
          <defs>
            <filter id="filter-seo-icon-6" x="0" y="0.813" width="48" height="42.375" filterUnits="userSpaceOnUse">
              <feImage preserveAspectRatio="none" x="0" y="0.8125" width="48" height="42.375" result="image" xlinkHref="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDIuMzc1IiB2aWV3Qm94PSIwIDAgNDggNDIuMzc1Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiB1cmwoI2xpbmVhci1ncmFkaWVudCk7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeTE9IjIxLjE4OCIgeDI9IjQ4IiB5Mj0iMjEuMTg4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZlNTA2YyIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmYzZhMmEiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQyLjM3NSIvPgo8L3N2Zz4K"></feImage>
              <feComposite result="composite" operator="in" in2="SourceGraphic"></feComposite>
              <feBlend result="blend" in2="SourceGraphic"></feBlend>
            </filter>
          </defs>
          <path filter="url(#filter-seo-icon-6)" d="M0,0.813H48V43.188H0V0.813H0ZM45.188,9.25V3.625H37.781L44.438,9.25h0.75ZM24.656,17.781h8.25l6.656-5.625h-8.25l-6.656,5.625h0ZM19.219,9.25h8.25L20.813,3.625h-8.25L19.219,9.25h0ZM27,12.156H18.75l-6.656,5.625h8.25L27,12.156h0ZM31.781,9.25h8.25L33.375,3.625h-8.25L31.781,9.25h0ZM2.813,3.625V9.25h12L8.156,3.625H2.813Zm0,8.531v5.625H7.688l6.656-5.625H2.813ZM45.188,40.375V20.594H2.813V40.375H45.188Zm0-22.594V12.156H43.969l-6.656,5.625h7.875Z" transform="translate(0 -0.813)"></path>
        </svg>
        </span>
      </div>
      <div class="contents">
        <h3>Design Services</h3>
        <p class="font-size-16 lh-165">Our team delivers creative & innovative design services.</p>
      </div>
    </div>
    
  </div>

</div>

<div class="lqd-column col-md-3">

  <div class="lqd-column-inner" data-parallax="true" data-parallax-from='{"translateY":50}' data-parallax-to='{"translateY":-130}' data-parallax-options='{"duration":"2000", "easing":"linear", "reverse":true, "triggerHook":"onEnter", "overflowHidden": false}'>

    <div class="iconbox text-left iconbox-round iconbox-lg iconbox-filled iconbox-filled iconbox-filled-hover iconbox-icon-image iconbox-shadow pt-50 pb-40">
      <div class="iconbox-icon-wrap">
        <span class="iconbox-icon-container mb-35">
        <svg width="31.219" height="48" viewBox="0 0 31.219 48" style={{ filter: "url(#filter-seo-icon-5)" }}>
          <defs>
            <filter id="filter-seo-icon-5" x="0.344" y="0" width="31.219" height="48" filterUnits="userSpaceOnUse">
              <feImage preserveAspectRatio="none" x="0.34375" y="0" width="31.219" height="48" result="image" xlinkHref="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzEuMjE5IiBoZWlnaHQ9IjQ4IiB2aWV3Qm94PSIwIDAgMzEuMjE5IDQ4Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiB1cmwoI2xpbmVhci1ncmFkaWVudCk7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeTE9IjI0IiB4Mj0iMzEuMjE5IiB5Mj0iMjQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmU1MDZjIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZjNmEyYSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iMzEuMjE5IiBoZWlnaHQ9IjQ4Ii8+Cjwvc3ZnPgo="></feImage>
              <feComposite result="composite" operator="in" in2="SourceGraphic"></feComposite>
              <feBlend result="blend" in2="SourceGraphic"></feBlend>
            </filter>
          </defs>
          <path filter="url(#filter-seo-icon-5)" d="M27.25,0a4.281,4.281,0,0,1,1.641.328,4.134,4.134,0,0,1,1.359.891,4.8,4.8,0,0,1,.938,1.359,3.026,3.026,0,0,1,.281,1.641l0.094,39.562a7.368,7.368,0,0,1-.375,1.641,3.156,3.156,0,0,1-.937,1.359,6.025,6.025,0,0,1-1.359.891A4.1,4.1,0,0,1,27.156,48H4.75a4.1,4.1,0,0,1-1.734-.328,5.993,5.993,0,0,1-1.359-.891,3.143,3.143,0,0,1-.937-1.359,7.287,7.287,0,0,1-.375-1.641L0.438,4.219A3,3,0,0,1,.719,2.578a4.77,4.77,0,0,1,.938-1.359A4.119,4.119,0,0,1,3.016.328,4.276,4.276,0,0,1,4.656,0H27.25ZM4.656,2.813a1.8,1.8,0,0,0-.562.094,0.754,0.754,0,0,0-.422.328,4.2,4.2,0,0,1-.328.469,0.514,0.514,0,0,0-.094.516L3.156,8.438H28.75L28.656,4.219A0.521,0.521,0,0,0,28.563,3.7a4,4,0,0,1-.328-0.469,0.754,0.754,0,0,0-.422-0.328,1.8,1.8,0,0,0-.562-0.094H4.656ZM28.75,11.25H3.156L3.25,33.844H28.656L28.75,11.25h0ZM27.156,45.188a1.632,1.632,0,0,0,.656-0.094,1.744,1.744,0,0,0,.422-0.328,1.436,1.436,0,0,0,.328-0.469c0.061-.155.125-0.328,0.188-0.516L28.656,36.75H3.25L3.156,43.781c0.062,0.188.125,0.36,0.188,0.516a1.392,1.392,0,0,0,.328.469,1.688,1.688,0,0,0,.422.328,1.622,1.622,0,0,0,.656.094H27.156Zm-9.75-4.219a3.6,3.6,0,0,1-.141-0.563,0.752,0.752,0,0,0-.281-0.469,1.923,1.923,0,0,0-.469-0.281,1.691,1.691,0,0,0-.609-0.094,2.045,2.045,0,0,0-.516.094,0.86,0.86,0,0,0-.469.281,3.142,3.142,0,0,0-.281.469,0.709,0.709,0,0,0-.047.563,0.592,0.592,0,0,0,.047.516,4.792,4.792,0,0,0,.281.422,1.112,1.112,0,0,0,.469.328,1.417,1.417,0,0,0,.516.141,1.177,1.177,0,0,0,.609-0.141,4.28,4.28,0,0,0,.469-0.328,0.733,0.733,0,0,0,.281-0.422,4.218,4.218,0,0,1,.141-0.516h0Z" transform="translate(-0.344)"></path>
        </svg>

        </span>
      </div>
      <div class="contents">
        <h3>Mobile App Development</h3>
        <p class="font-size-16 lh-165">We build intuitive & engaging Android & iOS Mobile Apps.</p>
      </div>
    </div>

    <div class="iconbox text-left iconbox-round iconbox-lg iconbox-filled iconbox-filled iconbox-filled-hover iconbox-icon-image iconbox-shadow pt-50 pb-40">
      <div class="iconbox-icon-wrap">
      <span className="iconbox-icon-container mb-35">
       
        <svg
          width="48"
          height="36.75"
          viewBox="0 0 48 36.75"
          style={{ filter: "url(#filter-seo-icon-7)" }}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          dangerouslySetInnerHTML={{
            __html: `
              <defs>
                <filter id="filter-seo-icon-7" x="0" y="0.625" width="48" height="36.75" filterUnits="userSpaceOnUse">
                  <feImage preserveAspectRatio="none" x="0" y="0.625" width="48" height="36.75" result="image" xlink:href="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iMzYuNzUiIHZpZXdCb3g9IjAgMCA0OCAzNi43NSI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogdXJsKCNsaW5lYXItZ3JhZGllbnQpOwogICAgICB9CiAgICA8L3N0eWxlPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHkxPSIxOC4zNzUiIHgyPSI0OCIgeTI9IjE4LjM3NSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZTUwNmMiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmM2YTJhIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0OCIgaGVpZ2h0PSIzNi43NSIvPgo8L3N2Zz4K"
                </filter>
              </defs>
              <path filter="url(#filter-seo-icon-7)" d="M16.781,3.438H48V37.375H0V3.438H8.625V0.625h8.156V3.438h0ZM45.188,34.563V14.781H40.781a6.936,6.936,0,0,1,.656,1.266,12.542,12.542,0,0,1,.469,1.406q0.187,0.7.328,1.453a8.139,8.139,0,0,1,.141,1.5,11,11,0,0,1-.891,4.406,11.446,11.446,0,0,1-6.047,6.047,10.984,10.984,0,0,1-4.406.891,10.645,10.645,0,0,1-4.359-.891,11.635,11.635,0,0,1-3.562-2.437,11.482,11.482,0,0,1-2.437-3.609,10.972,10.972,0,0,1-.891-4.406,12,12,0,0,1,.094-1.5,10.585,10.585,0,0,1,.281-1.453,8.381,8.381,0,0,1,.516-1.406,9.473,9.473,0,0,1,.7-1.266H2.813V34.563H45.188ZM39.563,20.406a7.951,7.951,0,0,0-.7-3.328,9.009,9.009,0,0,0-1.828-2.672,8.347,8.347,0,0,0-2.672-1.781,8.454,8.454,0,0,0-3.328-.656,8.216,8.216,0,0,0-3.234.656,8.916,8.916,0,0,0-2.719,1.781,7.95,7.95,0,0,0-1.828,2.672,8.768,8.768,0,0,0,0,6.656,7.949,7.949,0,0,0,1.828,2.672A8.889,8.889,0,0,0,27.8,28.188a8.189,8.189,0,0,0,3.234.656,8.427,8.427,0,0,0,3.328-.656,8.323,8.323,0,0,0,2.672-1.781,9.009,9.009,0,0,0,1.828-2.672,7.947,7.947,0,0,0,.7-3.328h0Zm-1.125-8.437h6.75V6.25H2.813v5.719H23.625A10.4,10.4,0,0,1,25.266,10.8a15.889,15.889,0,0,1,1.781-.891,9.251,9.251,0,0,1,1.922-.562,11.54,11.54,0,0,1,2.062-.187,11.312,11.312,0,0,1,2.109.188,10.571,10.571,0,0,1,1.922.563,12.033,12.033,0,0,1,1.781.891,11.792,11.792,0,0,1,1.594,1.172h0Z" transform="translate(0 -0.625)"></path>
            `,
          }}
        />
      </span>
      </div>
      <div class="contents">
        <h3>Cloud and DevOps</h3>
        <p class="font-size-16 lh-165">Our DevOps services are cornerstone of modern software development. </p>
      </div>
    </div>

  </div>

</div>

</div>

    </div>
  </section> */}
  {/*  */}
  <section class="vc_row pt-120 pb-90 bg-cover" style={{backgroundImage: "url(assets/img/banners/stats-banner.jpg)"}} data-parallax="true" data-parallax-options='{ "parallaxBG": true }'>
  <div class="container">
    <div class="row">
      
      <div class="lqd-column col-md-3 col-sm-6 text-center">
        
        <div class="liquid-counter liquid-counter-default text-white text-center">
          <div class="liquid-counter-element mb-2" data-fittext="true" data-fittext-options='{ "compressor": 0.5, "minFontSize": 70, "maxFontSize": 70 }' data-enable-counter="true" data-counter-options='{"targetNumber":"10+","blurEffect":true}'>
            {/* <span>10+</span> */}
            <h2 className="mb-2" style={{ color: "#ffffff", fontWeight: "bold", fontSize: "48px"  }}>
                  <CountUp start={0} end={10} duration={2.5} />+
              </h2>
          </div>
          <span class="liquid-counter-text liquid-text-bottom">Years of Experience</span>
        </div>
        
      </div>
      
      <div class="lqd-column col-md-3 col-sm-6 text-center">
        
        <div class="liquid-counter liquid-counter-default text-white text-center">
          <div class="liquid-counter-element mb-2" data-fittext="true" data-fittext-options='{ "compressor": 0.5, "minFontSize": 70, "maxFontSize": 70 }' data-enable-counter="true" data-counter-options='{"targetNumber":"24+","blurEffect":true}'>
            {/* <span>24+</span> */}
            <h2 className="mb-2" style={{ color: "#ffffff", fontWeight: "bold", fontSize: "48px"  }}>
                  <CountUp start={0} end={24} duration={2.5} />+
              </h2>
          </div>
          <span class="liquid-counter-text liquid-text-bottom">States and Union Territories</span>
        </div>
        
      </div>

        <div class="lqd-column col-md-3 col-sm-6 text-center">
        
        <div class="liquid-counter liquid-counter-default text-white text-center">
          <div class="liquid-counter-element mb-2" data-fittext="true" data-fittext-options='{ "compressor": 0.5, "minFontSize": 70, "maxFontSize": 70 }' data-enable-counter="true" data-counter-options='{"targetNumber":"580+","blurEffect":true}'>
            {/* <span>580+</span> */}
            <h2 className="mb-2" style={{ color: "#ffffff", fontWeight: "bold", fontSize: "48px"  }}>
                  <CountUp start={0} end={580} duration={2.5} />+
              </h2>
          </div>
          <span class="liquid-counter-text liquid-text-bottom">Locations</span>
        </div>
        
      </div>
      
      <div class="lqd-column col-md-3 col-sm-6 text-center">
        
        <div class="liquid-counter liquid-counter-default text-white text-center">
          <div class="liquid-counter-element mb-2" data-fittext="true" data-fittext-options='{ "compressor": 0.5, "minFontSize": 70, "maxFontSize": 70 }' data-enable-counter="true" data-counter-options='{"targetNumber":"10,000+","blurEffect":true}'>
            {/* <span>10,000+</span> */}
            <h2 className="mb-2" style={{ color: "#ffffff", fontWeight: "bold", fontSize: "48px"  }}>
                  <CountUp start={0} end={10000} duration={2.5} />+
              </h2>
          </div>
          <span class="liquid-counter-text liquid-text-bottom">Fintech Correspondents</span>
        </div>
        
      </div>
      
    
      
    </div>
  </div>
</section>
{/*  */}

<section className="vc_row bg-no-repeat pt-100 pb-100" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    
    {/* First Section - Left Content, Right Image */}
    <div className="row align-items-center mb-50">
      <div className="col-md-6">
        <div className="content">
          <h2>DocBoyz: Connecting India, One Verification at a Time</h2>
          <p>
          At DocBoyz, we don’t just operate across India—we empower it. From vibrant cities to remote villages, our nationwide network ensures seamless and secure financial services wherever they’re needed.
          With a presence in over 580+ locations and a dedicated network of over 10,000+ fintech correspondents, DocBoyz is the bridge between financial institutions and the people they serve.
          </p>
          </div>
          <div className="content">
  <div className="row">
    {/* Box 1 */}
    <div className="col-md-4">
      <div className="box">
        <h3>24+</h3>
        <p>States and Union Territories</p>
      </div>
    </div>
{/* 

 */}
    {/* Box 2 */}
    <div className="col-md-4">
      <div className="box">
        <h3>580+</h3>
        <p>Locations</p>
      </div>
    </div>

    {/* Box 3 */}
    <div className="col-md-4">
      <div className="box">
        <h3>10,000+ </h3>
        <p>Fintech Correspondents</p>
      </div>
    </div>
  </div>
</div>

      </div>
      <div className="col-md-6">
        <div className="image">
          <img src="assets/img/Home/India_Map.jpeg" alt="India Map" className="img-fluid" />
        </div>
      </div>
    </div>

    {/* Second Section - Icons with Information */}
    {/* <div className="row text-center">
      <div className="col-md-2">
        <img src="assets/icons/speed-icon.png" alt="Speed" className="img-fluid mb-2" />
        <p>Speed</p>
      </div>
      <div className="col-md-2">
        <img src="assets/icons/accuracy-icon.png" alt="Accuracy" className="img-fluid mb-2" />
        <p>100% Accuracy</p>
      </div>
      <div className="col-md-2">
        <img src="assets/icons/realtime-icon.png" alt="Real Time" className="img-fluid mb-2" />
        <p>Real Time Update</p>
      </div>
      <div className="col-md-2">
        <img src="assets/icons/data-security-icon.png" alt="Data Security" className="img-fluid mb-2" />
        <p>Data Security</p>
      </div>
      <div className="col-md-2">
        <img src="assets/icons/integration-icon.png" alt="Seamless Integration" className="img-fluid mb-2" />
        <p>Seamless Integration</p>
      </div>
    </div> */}

  </div>
</section> 


{/*  */}
{/* <section class="vc_row pt-55 pb-80"  data-ca-options='{"triggerHandler":"inview","animationTarget":".lqd-column","duration":"1200","delay":"150","easing":"easeOutQuint","direction":"forward","initValues":{"translateY":52,"opacity":0},"animations":{"translateY":0,"opacity":1}}'>
    <div class="container">

      <div class="row">

        <div class="lqd-column col-md-6 col-md-offset-3">

          <header class="fancy-title text-center mb-60">
            <h2>Testimonials</h2>
          </header>

        </div>

      </div>

      <div class="row">

        <div class="lqd-column col-md-6">

          <div class="testimonial testimonial-quote-filled text-center">
            <div class="testimonial-quote bg-athens-gray">
              <blockquote class="text-center font-size-16 lh-175">
                <p>I have had the pleasure of working with DocBoyz for the almost last five years. Not only have we been constantly amazed by the creative work and innovative approaches, we found ourselves working with a team of friends.</p>
              </blockquote>
            </div>
            <div class="testimonial-details">
              <figure class="avatar">
                <img src="assets/img/testimonials/pritesh.jpg" alt="Pritesh"></img>
              </figure>
              <div class="testimonial-info">
                <h5>Pritesh Mehetre</h5>
                <h6 class="font-weight-normal">Softwear Developer</h6>
              </div>
            </div>
          </div>

        </div>

        <div class="lqd-column col-md-6">

          <div class="testimonial testimonial-quote-filled text-center">
            <div class="testimonial-quote bg-athens-gray">
              <blockquote class="text-center font-size-16 lh-175">
                <p>Creative people, ready to solve any problem, one of few people who understand customers satisfaction and value creation. They’ve been enthusiastic and keen in producing quality product and with reliability, responsiveness, and transparency.</p>
              </blockquote>
            </div>
            <div class="testimonial-details">
              <figure class="avatar">
                <img src="assets/img/testimonials/pritesh.jpg" alt="Pritesh"></img>
              </figure>
              <div class="testimonial-info">
                <h5>Mahesh Kumar</h5>
                <h6 class="font-weight-normal">Regtech</h6>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </section> */}
  <section class="vc_row pt-40">
  <div class="container">
    <div class="row">

      <div class="lqd-column col-md-12 pull-down">

        <div class="lqd-column-inner pt-100 pb-110 border-radius-15 bg-cover bg-center" style={{backgroundImage: "url(assets/img/banners/contact-us-banner.png)"}}>

          <div class="row">

            <div class="col-md-6 col-md-offset-3 px-md-4 text-center"  data-ca-options='{"triggerHandler":"inview","animationTarget":"all-childs","duration":"1200","delay":"120","easing":"easeOutQuint","direction":"forward","initValues":{"translateY":70,"translateZ":-150,"rotateX":-65,"opacity":0},"animations":{"translateY":0,"translateZ":0,"rotateX":0,"opacity":1}}'>

              <hr class="w-10 border-color-primary"></hr>

              <h1 class="px-md-4 text-white">Let’s Work Together</h1>
              <p class="text-white mb-55" style={{fontSize: "22px"}}>Get in touch to let us know what you’re looking for and one of our solutions architects will get back to you soon.</p>

              <a class="btn btn-solid btn-md round font-weight-medium" >
        <span>
         <Link to="/contactus"><span class="btn-txt">Contact Us</span></Link> 
        </span>
      </a>
      {/* data-lity="#modal-1" */}


      <div id="modal-1" class="lqd-modal lity-hide">
        <div class="lqd-modal-inner">

          <div class="lqd-modal-head"></div>

          <div class="lqd-modal-content">

            <div class="row">

              <div class="lqd-column col-md-12 px-4 pt-45 pb-30">

                <div class="row d-flex flex-wrap align-items-center">

                  <div class="lqd-column col-md-6 col-md-offset-1">

                    <header class="fancy-title">
                      <h2>Drop us a line</h2>
                      <p>We are here to answer any question you may have</p>
                    </header>
                  </div>

                  <div class="lqd-column col-md-4 hidden-sm hidden-xs text-right">

                    <div class="iconbox text-right iconbox-xl" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"rgb(216, 219, 226)","hoverColor":"rgb(0, 0, 0)"}'>
                      <div class="iconbox-icon-wrap">
                        <span class="iconbox-icon-container">
                          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" enableBackground="new 0 0 64 64" xmlSpace="preserve"> <polygon strokeWidth="2" strokeLinejoin="bevel" strokeMiterlimit="10" points="1,30 63,1 23,41"></polygon> <polygon strokeWidth="2" strokeLinejoin="bevel" strokeMiterlimit="10" points="34,63 63,1 23,41"></polygon> </svg>
                        </span>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="row">

                  <div class="lqd-column col-md-10 col-md-offset-1">

                    <div class="contact-form contact-form-inputs-underlined contact-form-button-circle">
                      <form action="assets/php/mailer.php" method="post" noValidate="novalidate">
                        <div class="row d-flex flex-wrap">
                          <div class="lqd-column col-md-6 mb-20">
                            <input className="lh-25 mb-30" type="text" name="name" aria-required="true" aria-invalid="false" placeholder="First Name" required=""></input>
                            <input className="lh-25 mb-30" type="email" name="email" aria-required="true" aria-invalid="false" placeholder="Your email address" required=""></input>
                            <input className="lh-25 mb-30" type="tel" name="mobile" aria-required="true" aria-invalid="false" placeholder="Mobile no" required=""></input>
                          </div>
                          <div class="lqd-column col-md-6 mb-20">
                            <textarea cols="10" rows="6" name="message" aria-required="true" aria-invalid="false" placeholder="Message" required=""></textarea>
                          </div>
                          <div class="lqd-column col-md-6">
                            <p class="font-size-16 opacity-07"><em>We all know how important your information is. They are always safe with us.</em></p>
                          </div>
                          <div class="lqd-column col-md-6 text-md-right">
                            <input type="submit" value="Send message" class="font-size-13 ltr-sp-1 font-weight-bold"></input>
                          </div>
                        </div>
                      </form>
                      <div class="contact-form-result hidden"></div>
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

          <div class="lqd-modal-foot"></div>

        </div>
      </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  </div>
</section>
    </main>
  );
}